export function getCampagneName(model: any): string | null {
    if (model.Campagne || model.CampagneMarketing) {
        return model.Campagne ? model.Campagne.Nom : model.CampagneMarketing.Nom;
    }
    return null;
}

export function getCampagneId(model: any): number | null {
    if (model.Campagne || model.CampagneMarketing) {
        return model.Campagne ? model.Campagne.IDCampagne : model.CampagneMarketing.IDCampagneMarketing;
    }
    return null;
}